export default "__VITE_ASSET__CLj7Tw1L__"